import { PDFDocument } from "pdf-lib";
// export const createPdfFromSelectedPages = async (
//   originalFile,
//   selectedPages
// ) => {
//   const arrayBuffer = await originalFile.arrayBuffer();

//   const originalPdf = await PDFDocument.load(arrayBuffer);

//   const newPdf = await PDFDocument.create();

//   const copiedPages = await newPdf.copyPages(
//     originalPdf,
//     selectedPages.map((page) => page - 1)
//   );

//   copiedPages.forEach((page) => {
//     newPdf.addPage(page);
//   });

//   const pdfBytes = await newPdf.save();

//   const blob = new Blob([pdfBytes], {
//     type: "application/pdf",
//   });

//   return new File(
//     [blob],
//     originalFile.name,
//     {
//       type: "application/pdf",
//     }
//   );
// };

export const createPdfFromSelectedPages = async (
  originalFile,
  selectedPages
) => {
  let arrayBuffer;

  if (typeof originalFile === "string") {
    const response = await fetch(originalFile);

    if (!response.ok) {
      throw new Error("Unable to fetch PDF.");
    }

    arrayBuffer = await response.arrayBuffer();
  } else {
    arrayBuffer = await originalFile.arrayBuffer();
  }

  const originalPdf = await PDFDocument.load(arrayBuffer);

  const newPdf = await PDFDocument.create();

  const copiedPages = await newPdf.copyPages(
    originalPdf,
    selectedPages.map((page) => page - 1)
  );

  copiedPages.forEach((page) => {
    newPdf.addPage(page);
  });

  const pdfBytes = await newPdf.save();

  return new File(
    [new Blob([pdfBytes], { type: "application/pdf" })],
    "selected-pages.pdf",
    { type: "application/pdf" }
  );
};